import { InjectionToken } from '@angular/core';

export const BASE_PATH = new InjectionToken<string>('basePath');
export const API_KEY = new InjectionToken<string>('apiKey');
